// extracted by mini-css-extract-plugin
module.exports = {"container":"thankyou-module--container--1jPcd","message":"thankyou-module--message--3bQYj","body":"thankyou-module--body--2mku-"};